import styled from 'styled-components';
import { StyledKnowledgeArticle } from './knowledgeArticle.style';
import DefaultUptimeTheme from 'component/theme/defaultTheme';

export interface StyledKBDetailProps {
  theme?: typeof DefaultUptimeTheme;
}

export const StyledKBDetail = styled(StyledKnowledgeArticle)<StyledKBDetailProps>(({ theme }) => `
  font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
  overflow-x: scroll;
  color: ${theme.uptimeColors.textColors.primary};
  line-height: 1.42857;
  width: 100%;
  h1,
  .h1 {
    font-size: ${theme.uptimeFontSizes.desktop.fz12}px;
  }
  h2,
  .h2 {
    font-size: ${theme.uptimeFontSizes.desktop.fz11}px;
  }
  h3,
  .h3 {
    font-size: ${theme.uptimeFontSizes.desktop.fz9}px;
  }
  h4,
  .h4 {
    font-size: ${theme.uptimeFontSizes.desktop.fz6}px;
  }
  h5,
  .h5 {
    font-size: ${theme.uptimeFontSizes.desktop.fz4}px;
  }
  h6,
  .h6 {
    font-size: ${theme.uptimeFontSizes.desktop.fz2}px;
  }
  h1,
  .h1,
  h2,
  .h2,
  h3,
  .h3 {
    margin-top: ${theme.uptimeSpace[10]}px;
    margin-bottom: ${theme.uptimeSpace[5]}px;
  }
  h4,
  .h4,
  h5,
  .h5,
  h6,
  .h6 {
    margin-top: ${theme.uptimeSpace[5]}px;
    margin-bottom: ${theme.uptimeSpace[5]}px;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  .h1,
  .h2,
  .h3,
  .h4,
  .h5,
  .h6 {
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
  }
  p {
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    margin: 0 0 ${theme.uptimeSpace[5]}px;
  }
  ul,
  ol {
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    margin-top: 0;
    margin-bottom: ${theme.uptimeSpace[5]}px;
  }
  a {
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
    cursor: pointer;
    font-weight: bold;
    color: ${theme.uptimeColors?.generalColors?.button?.hyperlink?.enabled} !important;
    font-weight: 600;
    text-decoration: none;
    word-break: break-word;
    &:hover {
      text-decoration: underline !important;
      color: ${ theme.uptimeColors?.generalColors?.button?.hyperlink?.hover} !important;
    }
      span {
        color: ${theme.uptimeColors?.generalColors?.button?.hyperlink?.enabled} !important;
      }
      span:hover {
        color: ${theme.uptimeColors?.generalColors?.button?.hyperlink?.hover} !important;
      }
  }
  div, span {
    font-family: ${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`} !important;
  }
  video {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    h2 {
      .MuiIconButton-root {
        height: 70% !important;
      }
    }
  }
`);
